import styled from 'styled-components';

import { pulse } from 'utils/style/animations';
import { green, blue, black } from 'utils/style/colors';
import { InputTag } from 'components/Input/styles';
import Icon from 'components/Icon';
import Avatar from 'components/Avatar';
import { languageDirection } from '../../../../i18n';

interface IUserBoxProps {
  active: boolean;
}

interface ILineProps {
  color: string;
}

interface IContainerProps {
  hideOnSmall: boolean;
}
export const ChatsListContainer = styled('div')<IContainerProps>`
  flex: none;
  width: 22rem;
  display: flex;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  flex-direction: column;
  background-color: var(--exact-white);
  @media only screen and (max-width: 720px) {
    display: ${(props) => (props.hideOnSmall ? 'none' : 'flex')};
    width: 100%;
  }
`;

export const BoxWrapper = styled('div')`
  padding: 1rem;
  overflow: auto;
  //overflow: overlay;
  flex-direction: column;
`;

export const UserBox = styled('div')<IUserBoxProps>`
  color: ${(props) => (props.active ? `${green}` : '#454d56')};
  cursor: pointer;
  height: 5rem;
  display: flex;
  padding: 0.6rem;
  z-index: 1;
  position: relative;
  transition: all 0.3s ease;
  border-radius: 10px;
  align-items: center;
  background-color: ${(props) => props.active && '#f4f5f7'};
  :hover {
    background-color: #f4f5f7;
  }
`;

export const UserPhoto = styled(Avatar)`
  width: 40px;
  height: 40px;
  display: flex;
  font-size: 22px;
  align-self: center;
  box-sizing: border-box;
  align-items: center;
  margin-right: 0;
  justify-content: center;
`;

export const InfoBox = styled('span')`
  display: flex;
  font-size: 14px;
  align-items: center;
  margin-right: 0.7rem;
  justify-content: space-between;
`;

export const UserName = styled('span')`
  color: ${black};
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
`;

export const MessageText = styled('span')`
  color: #8d949f;
  overflow: hidden;
  font-size: 12px;
  max-width: 12rem;
  word-break: break-all;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: absolute;
  right: 0.6rem;
  bottom: 0.6rem;
`;

export const MessageDate = styled('span')`
  color: #8d949f;
  font-size: 12px;
  line-height: normal;
`;

export const UnreadPulse = styled('span')`
  width: 12px;
  height: 12px;
  animation: ${pulse} 1s infinite;
  background: ${blue};
  box-shadow: 0 0 0 rgba(0, 112, 224, 0.4);
  border-radius: 50%;
`;

export const InputWrapper = styled.div`
  width: 100%;
  z-index: 1;
  position: relative;
`;

export const Symbol = styled('span')`
  right: ${(_) => (languageDirection() === 'rtl' ? '10px' : '-10px')};
  width: 100%;
  color: #999999;
  bottom: 0;
  height: 100%;
  display: flex;
  position: absolute;
  font-size: 15px;
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  align-items: center;
  border-radius: 3rem;
  padding-inline-end: 2.2rem;
  pointer-events: none;
`;

export const InfoWrapper = styled('div')`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const ShadowInput = styled(InputTag)`
  &&& {
    padding: 0 4rem 0 3rem !important;
    /* border-color: #c8cee0 !important; */
    border-radius: 3rem !important;
    &::placeholder {
      font-weight: 500 !important;
    }
  }
  &:focus {
    + ${Symbol} {
      color: #0070e0;
      padding-right: 1.5rem;
    }
  }
`;

const setColor: { [key: string]: string } = {
  gray: '225, 28%, 83%',
  blue: '210, 100%, 44%',
};

export const Line = styled('hr')<ILineProps>`
  border: 0;
  height: 1px;
  transition: color 0.3s ease;
  background: -webkit-linear-gradient(
    left,
    hsla(${(props) => setColor[props.color]}, 0) 0%,
    hsla(${(props) => setColor[props.color]}, 0.85) 50%,
    hsla(${(props) => setColor[props.color]}, 0) 100%
  );
  background: -moz-linear-gradient(
    left,
    hsla(${(props) => setColor[props.color]}, 0) 0%,
    hsla(${(props) => setColor[props.color]}, 0.85) 50%,
    hsla(${(props) => setColor[props.color]}, 0) 100%
  );
`;

export const SymbolIcon = styled(Icon)`
  color: rgb(52, 200, 182);
  font-size: 17px;
  font-weight: 500 !important;
`;

export const CenterText = styled('div')`
  width: 100%;
  margin: 1.5rem 0;
  text-align: center;
  line-height: 0.1em;
  border-bottom: 1px solid #c8cee0;
`;

export const SearchText = styled('span')`
  color: ${blue};
  padding: 0 10px;
  background: var(--exact-white);
  font-weight: 400;
`;
